module.exports = __webpack_public_path__ + "static/media/hackerrankjava.7b790dda.png";